var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content", attrs: { id: "finance-manage" } },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showMainList,
              expression: "showMainList"
            }
          ],
          staticClass: "grid-view"
        },
        [
          _c(
            "div",
            { staticClass: "main-content" },
            [
              _c(
                "search-item",
                {
                  ref: "searchItem",
                  attrs: {
                    "is-simple-query": _vm.isSimpleQuery,
                    "auto-init": false,
                    "show-more-scheme": true,
                    "show-simple": true,
                    "expand-adv": true,
                    reset: "",
                    "custom-search-items": _vm.customSearchItems,
                    "search-item-code": _vm.$t("CargoMsg.Cargo_FinancialAudit"),
                    "custom-sim-query-placeholder": _vm.$t(
                      "Message.QuickSearchBusinessNo"
                    ),
                    "config-module": "1500"
                  },
                  on: {
                    "update:isSimpleQuery": function($event) {
                      _vm.isSimpleQuery = $event
                    },
                    "update:is-simple-query": function($event) {
                      _vm.isSimpleQuery = $event
                    },
                    query: _vm.queryHandler,
                    advToggle: _vm.scrollCallback
                  }
                },
                [
                  _c(
                    "template",
                    { slot: "operations" },
                    [
                      _c("closing-account-btn-group", {
                        attrs: {
                          "source-view": "manageList",
                          job: _vm.job,
                          hp: _vm.closingAccountHp
                        }
                      })
                    ],
                    1
                  )
                ],
                2
              ),
              _c(
                "div",
                {
                  staticClass: "section grid-wrapper",
                  staticStyle: { "min-height": "350px" }
                },
                [
                  _c("cargo-ag-grid", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      "config-module": "180301",
                      "grid-params": _vm.gridParams,
                      "grid-options": _vm.gridOptions,
                      "check-main-record": false,
                      "deselect-main-record": false,
                      "column-defs": _vm.columnDefs,
                      "row-data": _vm.rowData,
                      "show-selected-color": false
                    },
                    on: {
                      "update:gridParams": function($event) {
                        _vm.gridParams = $event
                      },
                      "update:grid-params": function($event) {
                        _vm.gridParams = $event
                      },
                      girdReady: _vm.onGridReady
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "pagination-wrapper",
                  attrs: { id: "footer-wrapper" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "total-wrapper",
                      class: [_vm.shouldFixed ? "fixedBottom" : ""]
                    },
                    [
                      _vm.reCalc
                        ? _c("charge-currency-total-group", {
                            key: 1,
                            attrs: {
                              "amount-to-currency": _vm.localCurrency,
                              mode: "simple",
                              "data-field": "incomeClosingAccount",
                              type: "both",
                              "data-provider":
                                _vm.closingAccountHp.dataProvider,
                              "currency-field": "currency",
                              "amount-to-currency-label": _vm.$t(
                                "queryJob.totalIncomeClosingAccount"
                              )
                            }
                          })
                        : _vm._e(),
                      _vm.reCalc
                        ? _c("charge-currency-total-group", {
                            key: 2,
                            attrs: {
                              "amount-to-currency": _vm.localCurrency,
                              mode: "simple",
                              "data-field": "costClosingAccount",
                              type: "both",
                              "data-provider":
                                _vm.closingAccountHp.dataProvider,
                              "currency-field": "currency",
                              "amount-to-currency-label": _vm.$t(
                                "queryJob.totalCostClosingAccount"
                              )
                            }
                          })
                        : _vm._e(),
                      _vm.reCalc
                        ? _c("charge-currency-total-group", {
                            key: 3,
                            attrs: {
                              "amount-to-currency": _vm.localCurrency,
                              mode: "simple",
                              "data-field": "realProfitClosingAccount",
                              type: "both",
                              "data-provider":
                                _vm.closingAccountHp.dataProvider,
                              "currency-field": "currency",
                              "amount-to-currency-label": _vm.$t(
                                "queryJob.profitClosingAccount"
                              )
                            }
                          })
                        : _vm._e(),
                      _vm.reCalc
                        ? _c("charge-currency-total-group", {
                            key: 4,
                            attrs: {
                              "amount-to-currency": _vm.localCurrency,
                              mode: "simple",
                              "data-field": "income",
                              type: "both",
                              "data-provider":
                                _vm.closingAccountHp.totalProfits,
                              "currency-field": "currency",
                              "amount-to-currency-label": _vm.$t(
                                "CargoMsg.Cargo_Receivable"
                              )
                            }
                          })
                        : _vm._e(),
                      _vm.reCalc
                        ? _c("charge-currency-total-group", {
                            key: 5,
                            attrs: {
                              "amount-to-currency": _vm.localCurrency,
                              mode: "simple",
                              "data-field": "cost",
                              type: "both",
                              "data-provider":
                                _vm.closingAccountHp.totalProfits,
                              "currency-field": "currency",
                              "amount-to-currency-label": _vm.$t(
                                "CargoMsg.Cargo_Dues"
                              )
                            }
                          })
                        : _vm._e(),
                      _vm.reCalc
                        ? _c("charge-currency-total-group", {
                            key: 6,
                            attrs: {
                              "amount-to-currency": _vm.localCurrency,
                              mode: "simple",
                              "data-field": "realProfit",
                              type: "both",
                              "data-provider":
                                _vm.closingAccountHp.totalProfits,
                              "currency-field": "currency",
                              "amount-to-currency-label": _vm.$t(
                                "CargoMsg.Cargo_Profit"
                              )
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _c("cargo-pagination", {
                    attrs: {
                      "config-module": "1500001",
                      total: _vm.searchConditions.total,
                      "page-count": _vm.searchConditions.pageCount,
                      page: _vm.searchConditions.pageNum,
                      limit: _vm.searchConditions.pageSize
                    },
                    on: {
                      "update:page": function($event) {
                        return _vm.$set(_vm.searchConditions, "pageNum", $event)
                      },
                      "update:limit": function($event) {
                        return _vm.$set(
                          _vm.searchConditions,
                          "pageSize",
                          $event
                        )
                      },
                      pagination: _vm.queryPageHandler
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c("closing-account-detail", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showDetail,
            expression: "showDetail"
          }
        ],
        ref: "closingAccountDetail",
        attrs: { "view-source": _vm.detailViewSource },
        on: { backList: _vm.toBackList, exportAll2Excel: _vm.exportAll2Excel }
      }),
      _c("c-a-business-commission", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showBusinessCommission,
            expression: "showBusinessCommission"
          }
        ],
        ref: "businessCommission",
        attrs: { visible: _vm.showBusinessCommission },
        on: {
          "update:visible": function($event) {
            _vm.showBusinessCommission = $event
          },
          viewDetail: _vm.showDetail4BusinessCommission,
          backList: function($event) {
            _vm.showBusinessCommission = false
          }
        }
      }),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.cxt,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          "pre-print-callback": _vm.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }